import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import i18next from "i18next";
import Quickview from "../main_compos/Quickview";
import RatingStars from "../../utils/RatingStars";
import { truncateString } from "../../utils/truncateString";
import { fileNotFound } from "../../assets/images/icons";

export default function RelatedProducts({ categoryId, localhost, t }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(localhost + "related-products/" + categoryId);
        const data = res.data;

        const updatedData = data.map(item => {
          const imgs = item.imgs ? JSON.parse(item.imgs) : null;
          const category = item.category ? JSON.parse(item.category) : null;
          return { ...item, category, imgs };
        });
        setProducts(updatedData);
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-[360px] flex items-center justify-center">
        <div className="loading-spinner" />
      </div>
    )
  }

  return (
    <div className="my-24">
      <p className="text-xl font-semibold text-black mb-6">{t("recommended-for-you")}</p>
      <div className="relative">
        <div className="swiper-button-prev absolute left-0 top-1/2 transform -translate-y-1/2 p-2 rounded-full cursor-pointer z-10">
          <ChevronLeftIcon className="size-4" />
        </div>
        <div className="swiper-button-next absolute right-0 top-1/2 transform -translate-y-1/2 p-2 rounded-full cursor-pointer z-10">
          <ChevronRightIcon className="size-4" />
        </div>

        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          slidesPerView={1}
          navigation={{
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
          }}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 5 },
          }}
          className="h-full"
        >
          {products.map((product, index) => (
            <SwiperSlide key={index} className="relative group">
              <OneProduct product={product} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}


const OneProduct = ({ product }) => {
  const localimg = process.env.REACT_APP_LOCALHOST_IMG;
  const productImg = product.imgs ? localimg + product.imgs[0] : fileNotFound;

  // check date :
  const checkDate = (date) => new Date() - new Date(date) <= 7 * 24 * 60 * 60 * 1000;

  const [imageLoaded, setImageLoaded] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (productImg) {
      const img = new Image();
      img.src = productImg;

      img.onload = () => {
        setImageLoaded(true);
        setShouldRender(true);
      };

      img.onerror = () => {
        setShouldRender(true);
      };
    }
  }, [productImg]);

  if (!shouldRender) {
    return (
      <div className="w-full max-w-sm rounded-lg shadow bg-white">
      </div>
    );
  }

  return (
    <div className="relative group">
      <div className="relative overflow-hidden aspect-w-1 aspect-h-1">
        <img loading="lazy" className={`object-cover w-full h-full transition-all duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`} alt="product" src={productImg} />
        <div className="absolute inset-0 flex bg-white/20 backdrop-blur-sm items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <Quickview slugProduct={product.slug} />
        </div>
      </div>
      <div className="absolute left-3 top-3">
        <p className={`sm:px-3 sm:py-1.5 px-1.5 py-1 text-[8px] sm:text-xs font-bold tracking-wide uppercase rounded-full
         ${checkDate(product.date) ? 'text-black bg-white' : 'text-white bg-black'}`}>
          {checkDate(product.date) ? 'New' : 'Sale'}
        </p>
      </div>
      <div className="flex items-start justify-between mt-2 space-x-4">
        <div>
          <h3 className="text-sm font-bold text-gray-900 md:text-base">
            <a href={`product/${product.slug}`} className='hover:underline'>
              {truncateString(product.name[i18next.language], 18)}
            </a>
          </h3>
          <div className="flex items-center mt-1 space-x-px">
            {
              product.ratings > 5 ?
                <RatingStars rating={product.ratings} size='12px' color='black' />
                : <p className='text-xs max-sm:text-[10px] text-black/60 leading-none'>
                  {product.category[i18next.language]}
                </p>
            }
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm font-bold text-gray-900 md:text-base">{product.price} MAD</p>
        </div>
      </div>
    </div>
  )
};
